import React from 'react';
import { DevErrorModal } from '~/components/Errors/DevErrorModal';

interface PageFallbackProps {
    error: CustomError;
}
export function PageFallback({ error }: PageFallbackProps) {
    return (
        <div className="container">
            <div className="row">
                <div className="col text-center">
                    <div className="h4">Sorry, we encountered an error!</div>
                    <DevErrorModal error={error} />
                </div>
            </div>
        </div>
    );
}
